import './utils/questions-answers';
import './utils/popup';

let navbarAnchor = document.querySelectorAll('.navbar__nav a');
let burgerMenu = document.getElementById('burger-btn');
let burgerMenuClose = document.getElementById('burger-btn-close');
let discountBanner = document.querySelector('.discount ');
let menuContainer = document.getElementById('mob-menu');

let closeBanner= document.querySelectorAll(".close-banner")

if(closeBanner) {
    closeBanner.forEach(item => {
        item.addEventListener('click', function(e){
            e.preventDefault();
            discountBanner.classList.remove("show");
            sessionStorage.setItem("Bullet-Banner", "Show");
        });
    })
}
navbarAnchor?.forEach(item => {
    item.addEventListener('click', function(){
        burgerMenu.classList.remove('active');
        menuContainer.classList.remove('active');
        document.body.classList.remove('no-scroll');
    });
})

burgerMenu?.addEventListener('click', function(){
    this.classList.toggle('active');
    menuContainer.classList.toggle('active');
    burgerMenuClose.classList.toggle('active');
    document.body.classList.toggle('no-scroll');
    if(discountBanner.classList.contains("show")) {
        discountBanner.style.display = "none"
    }

});
burgerMenuClose?.addEventListener('click', function(){
    this.classList.toggle('active');
    burgerMenu.classList.toggle('active');
    menuContainer.classList.toggle('active');
    document.body.classList.toggle('no-scroll');
    if(discountBanner.classList.contains("show")){
        discountBanner.removeAttribute("style");
    }
});

const bodyCells = document.querySelectorAll(".price-table-mark__body-cell p br");

// Создаем новый элемент <div>
bodyCells.forEach((bodyCell)=>{
    const divider = document.createElement("div");
    divider.className = "divider";
    bodyCell.parentNode.insertBefore(divider, bodyCell.nextSibling);
})

let blogMenu = document.querySelector(".sidebar__menu");
let blogMenuButton = document.querySelector(".sidebar__button");
blogMenuButton?.addEventListener("click",(event)=>{
    blogMenu.classList.toggle("active");
    blogMenuButton.classList.toggle("close")
})

let links=document.querySelectorAll(".nav-links div");

let guidesLinks=document.querySelectorAll(".content__post-nav-links");

document.addEventListener("DOMContentLoaded",(event)=>{
    if( sessionStorage.getItem("Bullet-Banner")!=="Show"){
        discountBanner.classList.add("show")
    }
    else{
        discountBanner.classList.remove("show")
    }

    if(links.length<2){
        links[0].style.maxWidth="100%";
    }
    console.log(guidesLinks)
    if(guidesLinks.length===0){
    }
})


